module.exports = __webpack_public_path__ + "img/schornstein_schiefer.73290be0.jpg";